<template>
  <div class="body">
    <el-container>
      <!-- <Aside /> -->
      <el-main>
        <el-row :gutter="10">
          <el-col :xl="9" :lg="9" :md="6" :sm="12">
            <div class="bg-White h">
              <SearchCustomers
                :searchOnly="true"
                :customer="customer"
                @selectedCustomer="selectedCustomer"
                :productsLength="productsLength"
                :productSearch="false"
                :showLabel="true"
              />
            </div>
          </el-col>
          <el-col :xl="9" :lg="9" :md="6" :sm="12" class="bg-White">
            <div class="block p-3 mt-2">
              <label for="" class="d-block"> اختر مده زمنيه</label>
              <el-date-picker
                style="width: 100%"
                @change="selectDateRange"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="7" :sm="24" v-if="customer">
            <div class="bg-White result">
              <p class="p-3 mt-2">
                <span
                  class="num"
                  v-if="+customer.balance + +customer.account >= 0"
                  >{{
                    numberToFixed(+customer.balance + +customer.account)
                  }}</span
                >
                <span class="num" v-else>{{
                  numberToFixed(
                    +customer.balance + +customer.account * -1
                  )
                }}</span>
                <br />
                <span v-if="+customer.balance + +customer.account >= 0"
                  >مدين</span
                >
                <span v-else>دائن</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row
          class="bg-White mt-2 p-3"
          v-if="customer"
          justify="space-between"
        >
          <el-col :xl="3" :lg="3" :md="6" :sm="12"> الفواتير </el-col>
          <el-col :xl="6" :lg="6" :pull="15" :md="6" :sm="12">
            <label for="code"></label>
            <el-input
              @change="selectSearchCode"
              placeholder="بحث بالفاتورة "
              autofocus
              type="text"
              @focus="$event.target.select()"
              v-model="searchCode"
            ></el-input>
          </el-col>
        </el-row>
        <el-table
          v-infinite-scroll="loadMoreData"
          class="mt-2"
          align="right"
          style="overflow: auto"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <!-- style="width: 100%" -->
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>
          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="الاجمالي" prop="total"> </el-table-column>
          <el-table-column
            width="180"
            label="عدد المنتجات"
            prop="products.length"
          >
          </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
          <template slot-scope="scope">
            {{scope.row.created_at | moment("Do / MM / YYYY")}}
          </template>
          </el-table-column>
          <el-table-column label="اجراءات" width="120">
            <template slot-scope="scope">
              <el-row :gutter="10">
                <el-col :lg="12">
                  <router-link
                    title="تعديل الفاتورة"
                    :to="{ path: '/sales/return/' + scope.row.id }"
                  >
                    <el-button size="mini" type="danger">
                      انشاء مرتجع
                    </el-button>
                  </router-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column type="expand" align="left">
            <template slot-scope="props">
              <el-table
                class="mt-2"
                align="right"
                :data="props.row.products"
                border
                style="width: 80%; margin: auto"
              >
                <el-table-column label="#" type="index" width="50">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column label="المنتج " prop="name"></el-table-column>
                <el-table-column sortable width="100" label="الكمية ">
                  <template slot-scope="scope">{{
                    scope.row.pivot.qty - scope.row.pivot.returned_qty
                  }}</template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="السعر "
                  prop="pivot.sale_price"
                ></el-table-column>
                <el-table-column label="الاجمالي">
                  <template slot-scope="scope">
                    {{ scope.row.pivot.qty * scope.row.pivot.sale_price }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
import Aside from "@/components/aside.vue";
import SearchCustomers from "@/components/Customers/SearchWithoutAdd.vue";

export default {
  name: "ReturnProduct",

  components: { Aside, SearchCustomers },

  data() {
    return {
      showHiden: false,
      buyCost: 0,
      totalDiscount: 0,
      filterMode: false,
      saleCost: 0,
      true: true,
      productsLength: 0,
      customer: null,
      customerAccount: this.customer
        ? Number(this.customer.balance) + Number(this.customer.account)
        : 0,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      pagination: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    // this.getSales();
  },
  methods: {
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getSales();
      }
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.filterMode = true;
      this.getSales();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getSales();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getSales();
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    getSales() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.getSalesCost();
      if (this.filterMode) {
        this.tableData = [];
      }
      let url = `inventory-sales/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}`;
      if (this.dateRange != null) {
        url += "&start_date=" + this.dateRange[0];
        url += "&end_date=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.customer != null) {
        url += "&customer=" + this.customer.id;
      }
      this.totalDiscount = 0;
      axiosApi
        .get(url)
        .then((res) => {
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;

          this.tableData.map((invoice) => {
            this.totalDiscount += +invoice.discount;
            invoice.total = this.numberToFixed(
              invoice.total_cost - invoice.discount
            );
            invoice.total_cost = this.numberToFixed(invoice.total_cost);
            invoice.discount = this.numberToFixed(invoice.discount);
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    async getSalesCost() {
      // let loader = this.$loading.show({});
      let link = `sales-cost/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?limit=20`;

      if (this.dateRange != null) {
        link += "&start=" + this.dateRange[0];
        link += "&end=" + this.dateRange[1];
      }

      if (this.searchCode != "") {
        link += "&id=" + this.searchCode.trim();
      }
      if (this.customer != null) {
        link += "&customer_id=" + this.customer.id;
      }
      await axiosApi
        .get(link)
        .then((res) => {
          this.buyCost = res.data[0].buyCost;
          this.saleCost = res.data[0].saleCost;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          // loader.hide();
        });
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 72%;
  overflow-y: scroll;
}
</style>
